import React from 'react'
import './AdminLayout.scss'
import { LoginAdmin } from '../../pages/Admin';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useAuth } from '../../hook';
import {TopMenu, SidebarMenu } from '../../components/Admin';

export function AdminLayout(props) {
  
  const {children} = props;

  const {auth} = useAuth();

  if(!auth) return <LoginAdmin/>
  
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFCA40', // Cambia el color primario
      },
      secondary: {
        main: '#ECECEC', // Cambia el color secundario
      },
    },

    typography: {
      fontFamily: 'Inter, sans-serif',
    },
    components: {
        MuiTableContainer: {
          styleOverrides: {
            root: {
              backgroundColor: '#fff', // fondo blanco
              borderRadius: '8px',     // ejemplo adicional
              border: '1px solid #e1e1e1',
              margin: '10px 0',
            },
          },
        },
       
      },
  });

  return (
    <div className='content__app'>      
     
     <div className='sidebar__row'>
      <div className='sidebar__menu'>
        <SidebarMenu />
      </div>
    </div>
    
    <div className='content__row'>
      <ThemeProvider theme={theme}>
      <TopMenu />
        <div className='content_area'>
          {children}
        </div>   
      </ThemeProvider>
    </div> 

    </div>
  )
}
